const calculateAvgRating = (reviews = []) => {
  // Handle empty reviews array
  if (!reviews?.length) return { totalRating: 0, avgRating: "" };

  const totalRating = reviews.reduce((acc, item) => acc + item.rating, 0);
  const avgRating = totalRating === 1 ? 1 : Number((totalRating / reviews.length).toFixed(1));

  return {
    totalRating,
    avgRating: avgRating || "" // Return empty string for 0 rating
  };
};

export default calculateAvgRating;